import React, { useState } from "react";
import TableOne from "../MarsVerifications/scoring-details/TableOne";
import "./TopSection.scss";
import RadioButton from "./RadioButton";

const topSectionRadioData = [
  {
    id: 1,
    label: "Yes",
    value: 1,
    name: "FSSC",
    isChecked: true,
  },
  {
    id: 2,
    label: "No",
    value: 0,
    name: "FSSC",
    isChecked: false,
  },
  {
    id:2,
    label: "Pending Corrective Action Review",
    value: 2,
    name: "FSSC",
    isChecked:true
  }
];

const TopSection = ({
  fsscScore,
  qmsScore,
  scoringLoading,
  onChangeCertification,
  isCertification,
  protocolDetails,
  scoringData
}) => {
  // isFfscCertificationRecommended
  const [selectedValue, setSelectedValue] = useState(
    // topSectionRadioData.find((item) => item.isChecked)?.value || ""
    scoringData?.isFfscCertificationRecommended
  );
  const fsscArray = fsscScore && fsscScore?.transformedData;
  const qmsArray = qmsScore && qmsScore?.transformedData;

  console.log("radio selected value ", selectedValue);

  return (
    <div className="scoring-top-section">
      <TableOne
        formDetails={qmsArray}
        firstColumn="QMS Results (Full Audit or Addendum)"
        scoringLoading={scoringLoading}
      />
        {protocolDetails && protocolDetails.ffscFindings && protocolDetails.ffscFindings.length !==0 && ( <TableOne
        formDetails={fsscArray}
        firstColumn="FSSC Results (if applicable)"
        scoringLoading={scoringLoading}
      />)}
     
      {isCertification && (
        <>
    
        <div className="radio-btn-section">
          <p>
            Will be recommended for FSSC Certification? 
        <span className="required-field"> *</span>
        </p> 
          {topSectionRadioData &&
            topSectionRadioData.length > 0 &&
            topSectionRadioData.map((radio) => (
              <RadioButton
                key={radio.id}
                id={radio.id}
                value={radio.value}
                label={radio.label}
                name={radio.name}
                isChecked={selectedValue === radio.value}
                onChange={(e) => {

                  console.log("e value", e)

                  setSelectedValue(e);
                  onChangeCertification(e);
                }}
              />
            ))}
        </div>
        <div style={{
          color: "red",
          marginTop: "0px",
          marginBottom: "20px"
        }} className="radio-btn-section">(This selection is a recommendation based on the current outcome subject to technical review and is not final)</div>
        </>
      )}

      {!scoringLoading && (
        <div className="scoring-top-section">
          <table style={{ width: "96%", margin: "auto" }}>
            <thead>
              <tr>
                <th
                  style={{
                    width: "75%",
                    padding: "7px 40px",
                    border: "1px solid #d4d4d4",
                    height: "93px",
                    fontSize: "16px",
                    color: "#262626",
                  }}
                >
                  Non Conformance Score
                </th>
                <th
                  style={{
                    width: "25%",
                    padding: "7px 40px",
                    border: "1px solid #d4d4d4",
                    height: "93px",
                    fontSize: "16px",
                    color: "#262626",
                    textAlign: "center",
                  }}
                >
                  {fsscScore?.totalNonConformanceScore ||
                  qmsScore?.totalNonConformanceScore
                    ? fsscScore?.totalNonConformanceScore +
                      qmsScore?.totalNonConformanceScore
                    : 0}
                </th>
              </tr>
            </thead>
          </table>
        </div>
      )}
    </div>
  );
};

export default TopSection;
